// extracted by mini-css-extract-plugin
export default {"CommentsButton":"ij_a bhe_wv bhe_iz bhe_xj bhe_i bhe_j bhe_q bhe_vr bhe_er bhe_sm bhe_sn bhe_eb","CommentsButton__icon":"ij_b bhe_rx"};